import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import ArticleList from './ArticleList'

const PAGE_SIZE = 9
const MOBILE_PAGE_SIZE = 5

const ArticlesList = ({ category, data, type }) => {
  const [filteredData, setFilteredData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)

  const { isMatching, calculated } = useMatchMedia('(max-width:610px)', true)
  const pageSize = isMatching && calculated ? MOBILE_PAGE_SIZE : PAGE_SIZE

  useEffect(() => {
    const categoryData = data?.filter((node) => node.data.type === type)
    setFilteredData(categoryData)
  }, [])

  const currentData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize
    const lastPageIndex = firstPageIndex + pageSize
    return filteredData?.slice(firstPageIndex, lastPageIndex)
  }, [currentPage, filteredData])

  const changePage = useCallback((page) => {
    setCurrentPage(page)
  }, [])

  return (
    <ArticleList
      data={currentData?.filter((node) => {
        return category
          ? node.data.article_categories.some(
              (item) => item.article_category === category,
            )
          : true
      })}
      currentPage={currentPage}
      setCurrentPage={changePage}
    />
  )
}

export default memo(ArticlesList)
